import { FiltersListItem } from '@common/Filters/containers/FiltersListItem';
import { useTranslation } from '@common/Hooks/useTranslation';
import { BEMBlock } from '@helpers/classnames';
import { getFiltersForView } from './helpers';
import { useFiltersList } from './useFiltersList';
import './FiltersList.scss';

export function FiltersList({
    filters,
    hasOrderFilter,
    theme
}) {
    const translate = useTranslation();
    const { activeFilter, handleHideFilters, handleFilterClick } = useFiltersList();

    const [block] = BEMBlock('filters-list', {
        [theme]: theme
    });

    const viewFilters = getFiltersForView(translate, filters, hasOrderFilter);

    return (
        <ul
            className={block}
            data-testid="listingFilters"
        >
            {viewFilters?.map(filter => (
                <FiltersListItem
                    key={filter.title}
                    activeFilter={activeFilter}
                    filter={filter}
                    theme={theme}
                    onClick={handleFilterClick}
                    onFilterCloseClick={handleHideFilters}
                />
            ))}
        </ul>
    );
}
